import classes from "../SeedLister.module.css"
import Input from "../../../components/UI/Input/Input"
import { useTranslation } from "react-i18next"

const Control = props => {
    const { t } = useTranslation()
    const dateOptions = props.scheduleData
        .map((e, idx) => {
            return (
                <option key={e.startTime} value={idx}>
                    {new Date(e.startTime).toLocaleDateString()} ({t("translation:CommonMsg.MatchMode." + e.type)})
                </option>
            )
        })
        .sort((a, b) => {
            return a.key > b.key
        })

    return (
        <div className={classes.Wrapper}>
            <Input
                type="select"
                title={t("translation:LayoutMsg.Cmn_MenuPhoto_00.T_Date_01")}
                options={dateOptions}
                changed={props.selectChange}
                val={props.scheduleData[props.selectValue]}
            />
            <Input type="number" title={t("misc:Checker.NumberOfSlots")} changed={props.inputChange} val={props.inputValue} />
            <Input type="checkbox" title={"Only Show Scales"} changed={props.scalesChange} val={props.scalesValue} />

            <div>
                <button className={classes.Button} onClick={() => props.calculateResults(props.scalesValue)}>
                    {t("misc:Checker.ButtonDisplayResults")}
                </button>
            </div>
        </div>
    )
}

export default Control
